var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"ma-0 fill-height"},[_c('v-card',{staticClass:"pa-4",attrs:{"height":"100%","width":"100%"}},[_c('RewardEditInformation',{attrs:{"reward-id":_vm.rewardId}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }